import { createAction, props } from '@ngrx/store';

import { ActiveReference } from '../../interfaces/active-reference';

/** Set active reference action */
export const setActiveReference = createAction(
  '[News Feed] Set Active Reference',
  props<{ reference: ActiveReference | null }>(),
);
